window["ThemeSection_CustomProduct"] = () => {
  return {
    init() {
      console.log("Initialization...");
      this.handlePageLoad(); // Handle overlay and color settings on page load
    },

    updateUrl(newUrl) {
      const state = {};
      const title = document.title;
      history.pushState(state, title, newUrl);
    },

    initSlider() {
      // Check if viewport width is less than or equal to 1023px
      if (window.matchMedia("(max-width: 1023px)").matches) {
        new Splide("#splide", {
          perPage: 1,
          autoplay: false,
          updateOnMove: true,
          pagination: false,
          arrows: false,
        }).mount();
      }
    },

    loadProduct(handle) {
      const productUrl = `${Shopify.routes.root}products/${handle}?view=custom-flavour`;

      fetch(productUrl)
        .then((response) => response.text())
        .then((htmlString) => {
          const html = new DOMParser().parseFromString(htmlString, "text/html");
          const productData = html.querySelector("#contentArea");

          // Inject the fetched product content
          this.$refs.contentArea.innerHTML = productData.innerHTML;

          // Reinitialize Alpine.js for the new content
          Alpine.flushAndStopDeferringMutations();
          if(window.SealSubs && window.SealSubs.refresh) {
            window.SealSubs.refresh();
          }
          // Alpine.initTree(this.$refs.contentArea);

          // this.init();

          // Trigger the transition overlay animation
          // this.triggerOverlayAnimation();
          const overlay = document.getElementById("transitionOverlay");
          overlay.style.transition = "transform 1s ease";
          overlay.style.transform = "translate(0%, 0)";

          // Force layout reflow before setting the next transform
          overlay.offsetHeight;

          setTimeout(() => {
            overlay.style.transform = "translate(100%, 0)";
          }, 1000);

          // After animation, set the color from the active button
          // setTimeout(this.updateProductColors, 1000);
          this.updateProductColors();

          // Update the URL to the new product view
          this.updateUrl(`/products/${handle}?view=custom-flavour`);

          // Initialize the slider for the new product
          // this.initSlider();
        })
        .catch((error) => console.error("Error fetching content:", error));
    },

    triggerOverlayAnimation() {
      const overlay = document.getElementById("transitionOverlay");
      overlay.style.transition = "transform 1s ease";
      overlay.style.transform = "translate(0%, 0px)";

      // Force layout reflow before setting the next transform
      overlay.offsetHeight;

      setTimeout(() => {
        overlay.style.transform = "translate(100%, 0px)";
      }, 1000);
    },

    updateProductColors() {
      const activeButton = document.querySelector(".vc_main .vc_link.active");
      if (activeButton) {
        const color = activeButton.getAttribute("data-color");
        const sectionColor = activeButton.getAttribute("data-section-color");

        // Set the product-specific colors using CSS variables
        setTimeout(() => {
          document.documentElement.style.setProperty("--prod-color-main", color);
        }, 1000);
        document.documentElement.style.setProperty(
          "--prod-section-color",
          sectionColor
        );
      }
    },

    handlePageLoad() {
      window.addEventListener("load", () => {
        console.log("Load Event Fired!!");

        // Init slider
        this.initSlider();

        // Trigger overlay animation
        this.triggerOverlayAnimation();

        // Set product colors after page load
        this.updateProductColors();
      });
    },
  };
};